import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import * as React from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse, Checkbox} from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People'
import LocalDiningIcon from '@material-ui/icons/LocalDining'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ReportsIcon from '@material-ui/icons/Assessment'
import { observer } from 'mobx-react';
import {observable, action} from 'mobx';

export interface ITurnusProgressIndicatorProps {
    progress: number;
    length: number;
}

@observer
class TurnusProgressIndicator extends React.Component<ITurnusProgressIndicatorProps>{

    @observable private reportsOpen: boolean = false;

    @action
    private handleReportSection = () => {
        this.reportsOpen = !this.reportsOpen;
    }

    public render() {

        if(this.props.progress === 0) {
            return "Nezačal";
        } else if(this.props.progress === -1) {
            return "Skončil";
        } else {
            return (
                <span>
                    <span />
                    {Array(this.props.length).fill(0).map((n,i) => (
                        <Checkbox checked={(this.props.progress >= (i+1)) ? true : false} style={{paddingRight: '0px'}}/>
                    ))}
                </span>
            )
        }
    }
}

export default TurnusProgressIndicator;



// WEBPACK FOOTER //
// ./src/components/TurnusProgressIndicator.tsx